import { Box, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { ViewToggleButtonGroup } from "../../../components";
import { useBreakpoints } from "../../../hooks";
import { UserIssuesList, UserTaskItemsList } from "./components";
import { useUserImplementationSettings } from "./hooks";

interface IParams {
  userId: string;
}

const UserImplementationPage = () => {
  const { userId: userGuid } = useParams<keyof IParams>() as IParams;
  const { isMdUp } = useBreakpoints();
  const { settings, updateSettings } = useUserImplementationSettings(userGuid);
  const [isTableView, setIsTableView] = useState(true);

  useEffect(() => {
    handleViewToggled(settings.tableView);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userGuid]);

  useEffect(() => {
    if (isMdUp) {
      setIsTableView(settings.tableView);
    } else {
      setIsTableView(false);
    }
  }, [isMdUp, userGuid, settings]);

  function handleViewToggled(value: boolean) {
    setIsTableView(value);
    updateSettings({
      tableView: value,
    });
  }

  return (
    <Stack spacing={1}>
      <Card>
        <CardContent>
          <Stack direction="row" spacing={1} sx={{ alignItems: "center", justifyContent: "space-between" }}>
            <Stack spacing={0.25}>
              <Typography variant="h5">Implementation</Typography>
              <Typography>Tasks and Issues</Typography>
            </Stack>
            {isMdUp && <ViewToggleButtonGroup isTableView={isTableView} onViewToggled={handleViewToggled} />}
          </Stack>
        </CardContent>
      </Card>
      <Box>
        <Grid container spacing={1}>
          <Grid size={{ xs: 12, lg: isTableView ? 12 : 8 }}>
            <UserTaskItemsList userGuid={userGuid} isTableView={isTableView} />
          </Grid>
          <Grid size={{ xs: 12, lg: isTableView ? 12 : 4 }}>
            <UserIssuesList userGuid={userGuid} isTableView={isTableView} />
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
};

export { UserImplementationPage };
